import { render, staticRenderFns } from "./ProductNoveltyBadge.vue?vue&type=template&id=cbd582c6"
import script from "./ProductNoveltyBadge.vue?vue&type=script&lang=js"
export * from "./ProductNoveltyBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports